/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GenderComposition = {
    Male: 'Male',
    Female: 'Female',
    Coeducation: 'Coeducation'
} as const;
export type GenderComposition = typeof GenderComposition[keyof typeof GenderComposition];


export function instanceOfGenderComposition(value: any): boolean {
    for (const key in GenderComposition) {
        if (Object.prototype.hasOwnProperty.call(GenderComposition, key)) {
            if (GenderComposition[key as keyof typeof GenderComposition] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GenderCompositionFromJSON(json: any): GenderComposition {
    return GenderCompositionFromJSONTyped(json, false);
}

export function GenderCompositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenderComposition {
    return json as GenderComposition;
}

export function GenderCompositionToJSON(value?: GenderComposition | null): any {
    return value as any;
}

export function GenderCompositionToJSONTyped(value: any, ignoreDiscriminator: boolean): GenderComposition {
    return value as GenderComposition;
}

